#!/usr/bin/env node

import { createProgram } from './commands/index.js'

createProgram().parse()
